import React, {useCallback, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner,
} from "material-react-table";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import {constantsErrorMessages} from "../../../../../Constants";
import ModalAlert from "../ModalAlert";
import ModalAddVariable from "./ModalAddVariable";
import ButtonCreate from "../../../button/ButtonCreate";
import MenuItem from "@mui/material/MenuItem";
import VariableControllerService from "../../../../../API/details/customer/VariableControllerService";
import VariableControllerServiceOrganization
    from "../../../../../API/details/organization/VariableControllerServiceOrganization";
import {replaceEmptyStringsOnNull} from "../../../../../utils/ReplaceEmptyStringsOnNull";
import CompositionsPatternVariablesService from "../../../../../API/organization/CompositionsPatternVariablesService";
import CompositionsVariablesService from "../../../../../API/organization/CompositionsVariablesService";
import CompositionsPacedDetailVariablesService
    from "../../../../../API/organization/CompositionsPacedDetailVariablesService";
import CompositionsPacedModuleVariablesService
    from "../../../../../API/organization/CompositionsPacedModuleVariablesService";
import {
    normalizeVariablesTableRows,
    resolveCompositionVariableRecordId,
} from "../../../../../utils/compositionVariables";
const immutableVariables = ["W", "H", "L"]

const VariablesTable = ({
                            data, isError, setData, enableEditing, enableRowSelection, orderId, detailId, organization,
                            tableOptions,
                            tableOptionsHandle,
                            moduleId,
                            detailPatternId,
                            patterns,
                            pacedDetailModule,
                            pacedDetailModuleId,
                            pacedModule,
                            pacedModuleId,
                            globalFilter,
                            handleSearchQuery,
                            filteredData,
                            columnsFilter,
                        }) => {
    const rowInitValue = {name: "", pattern: "", comment: ""}

    const [variableModalOpen, setVariableModalOpen] = useState(false);
    const [alertData, setAlertData] = useState({});

    const [rowSelection, setRowSelection] = useState({});
    const [currentEditRowData, setCurrentEditRowData] = useState(rowInitValue);
    const [currentEditRowId, setCurrentEditRowId] = useState(null);
    const [isNew, setIsNew] = useState(true);
    const [loading, setLoading] = useState(false)
    const [showColumnFilters, setShowColumnFilters] = useState(false)

    const handleShowColumnFilters = () => {
        setShowColumnFilters(!showColumnFilters)
        if (showColumnFilters) {
            handleSearchQuery([], data, null, true)
        }
    }
    const handleCloseAlert = () => {
        setAlertData((alert) => {
            return {...alert, open: false}
        })
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const handleClose = () => {
        setVariableModalOpen(false)
        setIsNew(true)
        setCurrentEditRowData(rowInitValue)
        setCurrentEditRowId(null)
    }

    const resolveRowRecordId = useCallback((row) => resolveCompositionVariableRecordId(row), [])

    const handleUpdate = (formValues) => {
        if (currentEditRowId == null || currentEditRowId === "") {
            handleModalAlert(new Error("Не удалось определить id переменной"))
            return
        }
        setLoading(true)
        const api = pacedModule
            ? CompositionsPacedModuleVariablesService.edit(currentEditRowId, replaceEmptyStringsOnNull(formValues))
            : pacedDetailModule
            ? CompositionsPacedDetailVariablesService.edit(currentEditRowId, replaceEmptyStringsOnNull(formValues))
            : patterns
                ? CompositionsPatternVariablesService.edit(currentEditRowId, replaceEmptyStringsOnNull(formValues))
                : moduleId
                    ? CompositionsVariablesService.edit(currentEditRowId, replaceEmptyStringsOnNull(formValues))
                    : organization
                        ? VariableControllerServiceOrganization.edit(currentEditRowId, replaceEmptyStringsOnNull(formValues))
                        : VariableControllerService.edit(orderId, detailId, currentEditRowId, replaceEmptyStringsOnNull(formValues))
        api.then(function (response) {
            const responseId = resolveCompositionVariableRecordId(response.data) ?? response.data?.id
            const newData = data.map((el) => (
                String(resolveRowRecordId(el)) === String(responseId) ? response.data : el
            ))
            setData(newData)
            handleSearchQuery(globalFilter, newData)
            handleModalAlert("Данные изменены", 'success')
            handleClose()
        })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    const handleDeleteVariable = (row) => {
        const variableId = resolveRowRecordId(row)
        if (variableId == null) {
            handleModalAlert(new Error("Не удалось определить id переменной"))
            return
        }
        const api = pacedModule
            ? CompositionsPacedModuleVariablesService.delete(variableId)
            : pacedDetailModule
            ? CompositionsPacedDetailVariablesService.delete(variableId)
            : patterns
                ? CompositionsPatternVariablesService.delete(variableId)
                : moduleId
                    ? CompositionsVariablesService.delete(variableId)
                    : organization
                        ? VariableControllerServiceOrganization.delete(variableId)
                        : VariableControllerService.delete(orderId, detailId, variableId)
        api.then(function () {
            const newData = data.filter((el) => resolveRowRecordId(el) !== variableId)
            setData(newData)
            handleSearchQuery(globalFilter, newData)
            handleModalAlert("Данные удалены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };

    const handleSubmit = (value) => {
        setLoading(true)
        const api = pacedModule
            ? CompositionsPacedModuleVariablesService.save(pacedModuleId, replaceEmptyStringsOnNull(value))
            : pacedDetailModule
            ? CompositionsPacedDetailVariablesService.save(pacedDetailModuleId, replaceEmptyStringsOnNull(value))
            : patterns
                ? CompositionsPatternVariablesService.save(moduleId, detailPatternId, replaceEmptyStringsOnNull(value))
                : moduleId
                    ? CompositionsVariablesService.save(moduleId, replaceEmptyStringsOnNull(value))
                    : organization
                        ? VariableControllerServiceOrganization.save(detailId, replaceEmptyStringsOnNull(value))
                        : VariableControllerService.save(orderId, detailId, replaceEmptyStringsOnNull(value))
        api.then(function (response) {
            const newData = [...data, response.data]
            setData(newData)
            handleSearchQuery(globalFilter, newData)
            handleModalAlert("Данные добавлены", 'success')
            handleClose()
        })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    const handleAddVariable = () => {
        setCurrentEditRowId(null)
        setIsNew(true)
        setCurrentEditRowData(rowInitValue)
        setVariableModalOpen(true)
    };

    const handleEditVariable = (row) => {
        const recordId = resolveRowRecordId(row)
        if (recordId == null) {
            handleModalAlert(new Error("У переменной нет id — её нельзя изменить через API"))
            return
        }
        setCurrentEditRowData((prev) => {
            return Object.keys(prev).reduce((acc, it) => ({...acc, [it]: row[it]}), {})
        });
        setVariableModalOpen(true)
        setCurrentEditRowId(recordId);
        setIsNew(false);
    };

    const columns = useMemo(() => {
        const formatNumber = (raw) => {
            if (raw == null || raw === "") return "";
            const n = Number(raw);
            return Number.isFinite(n) ? n.toFixed(2) : String(raw);
        };
        const baseColumns = [{
            id: 'name', header: 'Наименование', accessorKey: 'name', minSize: 60,
        }, {
            id: 'pattern', header: 'Значение', accessorKey: 'pattern', Cell: ({row}) => {
                const raw = row.original.pattern;
                if (raw == null || raw === "") return "";
                const numberPattern = Number(raw);
                return Number.isNaN(numberPattern) ? raw : numberPattern.toFixed(2);
            }
        }, {
            id: 'value',
            header: 'Текущее значение',
            accessorKey: 'value',
            Cell: ({row}) => formatNumber(row.original.value),
        }, {
            id: 'comment', header: 'Комментарий', accessorKey: 'comment',
        },]

        return baseColumns;

    }, [data, filteredData]);
    const menuItem = [
        {type: "edit", text: "Редактировать", handler: handleEditVariable},
        {type: "delete", text: "Удалить", handler: handleDeleteVariable}
    ]
    return (<div>
        {enableEditing && (
            <Box sx={{display: "flex", justifyContent: "flex-end", paddingBottom: "30px"}}>
                <ButtonCreate
                    text={"Добавить"}
                    width={140}
                    onClick={handleAddVariable}
                    disabled={isError}
                />
            </Box>
        )}
        <MaterialReactTable
            renderTopToolbar={({table}) => (
                <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            )}
            selectAllMode={"all"}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "&:after": {
                        display: "none",
                    },
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "&:first-of-type": enableEditing && {
                        padding: 0,
                        width: "100%",
                        height: "36px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: (theme) => theme.palette.text.light,
                        "& .MuiButtonBase-root": {
                            borderRadius: "4px",
                            width: "24px",
                            height: "24px",
                            opacity: 1,
                            margin: 0,
                            padding: 0,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            }
                        }
                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    sx: () => ({
                        height: '36px',
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&.MuiTableRow-root.Mui-selected": {
                            backgroundColor: (theme) => theme.palette.primary.light70,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.light50,
                            },
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                            backgroundColor: (theme) => theme.palette.primary.stroke,
                        },
                        '&:nth-of-type(even)': {
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            backgroundColor: (theme) => theme.palette.primary.lightGrey,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: 3,
                    minSize: 3,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={isError ? [] : filteredData}
            rowHeight={13}
            columnSpacing={1}
            onRowSelectionChange={setRowSelection}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            onGlobalFilterChange={(value) => {
                handleSearchQuery(value, data, null)
            }}
            onColumnFiltersChange={(updater) => {
                handleSearchQuery(updater(columnsFilter), data, null, true)
            }}
            onShowColumnFiltersChange={handleShowColumnFilters}
            manualPagination={true}
            rowCount={tableOptions.totalElements}
            state={{
                showColumnFilters: showColumnFilters,
                columnFilters: columnsFilter,
                globalFilter: globalFilter,
                rowSelection,
                showGlobalFilter: true,
                pagination: tableOptions
            }}
            enableRowSelection={enableRowSelection}
            getRowId={(originalRow) => {
                const recordId = resolveRowRecordId(originalRow)
                if (recordId != null) {
                    return String(recordId)
                }
                return String(originalRow.name ?? "")
            }}
            selectionPadding={1}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return <MenuItem
                    key={el.type}
                    disabled={immutableVariables.includes(row.original.name)}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })}
            localization={MRT_Localization_RU}
            enableRowActions={enableEditing}
            positionActionsColumn="first"
            enableToolbarInternalActions={false}
        />
        <ModalAddVariable
            title={isNew ? "Добавить переменную" : "Изменить переменную"}
            initValue={currentEditRowData}
            open={variableModalOpen}
            onClose={handleClose}
            handleSubmit={isNew ? handleSubmit : handleUpdate}
            labelButtonSubmit={isNew ? 'Создать' : 'Обновить'}
            loading={loading}
        />
        <ModalAlert data={alertData} onClose={handleCloseAlert}/>
    </div>);
};

export default VariablesTable;
